import { ElementRef } from '@angular/core';
import { PasskeyLoginErrorService } from './passkey-login-error.service';
import { CookieService } from 'ngx-cookie-service';
import { PasskeysService } from 'PasskeysApp/services/passkeys.service';
import * as i0 from "@angular/core";
import * as i1 from "PasskeysApp/services/passkeys.service";
import * as i2 from "ngx-cookie-service";
import * as i3 from "./passkey-login-error.service";
function PasskeyLoginComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
    i0.ɵɵlistener("click", function PasskeyLoginComponent_Conditional_0_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.login()); });
    i0.ɵɵtext(2, "Log in with Passkey");
    i0.ɵɵelementEnd()();
} }
const PASSKEY_LOGIN_HINT_COOKIE = 'passkey_login_hint';
const CREDENTIAL_UNKNOWN_MESSAGE = 'This passkey is no longer valid. Please sign in with your password.';
const EMAIL_MISMATCH_MESSAGE = "We couldn't link your social account because it's associated with a " +
    'different email than the one you signed in with.';
export class PasskeyLoginComponent {
    constructor(passkeysService, cookieService, passkeyLoginErrorService, eltRef) {
        this.passkeysService = passkeysService;
        this.cookieService = cookieService;
        this.passkeyLoginErrorService = passkeyLoginErrorService;
        this.eltRef = eltRef;
        this.showFallbackLink = false;
        this.handleLoginSuccess = (response) => {
            // URL comes in the response only when the login is successful, and it was already validated by the backend.
            window.location.href = response.url;
        };
        this.handleLoginError = (error) => {
            if (error.name === 'NotAllowedError') {
                // User cancelled the login prompt.
                return;
            }
            if (error.status === 403 && error.error?.error === 'credential_unknown') {
                // Server has no record of this credential — likely deleted via admin.
                // Cookie was cleared by the server and the credential was signaled to the
                // authenticator, so this is the only prompt the user will see.
                this.showFallbackLink = false;
                this.passkeyLoginErrorService.setError(CREDENTIAL_UNKNOWN_MESSAGE);
            }
            else if (error.status === 403 && error.error?.error === 'email_mismatch') {
                this.passkeyLoginErrorService.setError(EMAIL_MISMATCH_MESSAGE);
            }
            else if (error.status === 403) {
                this.passkeyLoginErrorService.setError('Invalid Passkey.');
            }
            else {
                this.passkeyLoginErrorService.setError('Server is unable to process the provided key.');
            }
        };
    }
    ngOnInit() {
        // If we're in manual mode and this event is triggered, it means we're in the account login wizard at the
        // social login linking step, and we should avoid prompting the component to automatically show up or autofill
        this.eltRef.nativeElement.addEventListener('ycn-trigger-passkey-login', () => this.login());
        if (this.eltRef.nativeElement.hasAttribute('data-manual')) {
            return;
        }
        // The hint cookie is set server-side after a successful passkey registration or login.
        // Its presence tells us this browser has used a passkey on this site before, so we can
        // auto-trigger the modal flow. Conditional UI still runs as a fallback if the cookie
        // is missing (e.g. browser data was cleared).
        if (this.cookieService.check(PASSKEY_LOGIN_HINT_COOKIE)) {
            this.showFallbackLink = true;
            this.login();
            return;
        }
        if (typeof window.PublicKeyCredential?.isConditionalMediationAvailable !== 'function') {
            return;
        }
        PublicKeyCredential.isConditionalMediationAvailable().then((available) => {
            if (available) {
                this.loginConditional();
            }
        });
    }
    login() {
        this.passkeysService.authenticatePasskey().subscribe({
            next: this.handleLoginSuccess,
            error: this.handleLoginError,
        });
    }
    loginConditional() {
        this.passkeysService.authenticatePasskeyConditional().subscribe({
            next: this.handleLoginSuccess,
            // The conditional request runs passively in the background, so most errors
            // (e.g. NotAllowedError when no passkey is available) should not be surfaced.
            // The exception is credential_unknown: the user actively picked a passkey from
            // autofill and the server rejected it, so we need to tell them why nothing happened.
            error: (error) => {
                if (error.status === 403 && error.error?.error === 'credential_unknown') {
                    this.passkeyLoginErrorService.setError(CREDENTIAL_UNKNOWN_MESSAGE);
                }
            },
        });
    }
}
PasskeyLoginComponent.ɵfac = function PasskeyLoginComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasskeyLoginComponent)(i0.ɵɵdirectiveInject(i1.PasskeysService), i0.ɵɵdirectiveInject(i2.CookieService), i0.ɵɵdirectiveInject(i3.PasskeyLoginErrorService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
PasskeyLoginComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasskeyLoginComponent, selectors: [["ycn-passkey-login"]], standalone: false, decls: 1, vars: 1, consts: [[1, "form-link", "pb-4px"], ["href", "javascript:void(0)", 3, "click"]], template: function PasskeyLoginComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, PasskeyLoginComponent_Conditional_0_Template, 3, 0, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.showFallbackLink ? 0 : -1);
    } }, encapsulation: 2 });
